/**
 * Embed My Docs
 *
 * Shows user's personal documents in iframe mode.
 *
 * Deep link: `/embed/my-docs?folder=<id>&file=<id>` lands in that folder and
 * opens the file's viewer (the signing panel for a signed document, the
 * editor otherwise) — what a wrapper such as zehn/abat sends a person to.
 * The folder part is a redirect to the folder route; the file part rides
 * along as `?file=` and FoldersTable opens it once the listing is up.
 */

import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useEmbedAuth } from '@/shared/contexts/EmbedAuthContext';
import { MyDocs } from '@/modules/my-docs/index.jsx';

export default function EmbedMyDocs() {
    useEmbedAuth();
    const [params] = useSearchParams();
    const folder = params.get('folder');
    const file = params.get('file');
    if (folder && /^\d+$/.test(folder)) {
        return <Navigate to={`/files/${folder}${file ? `?file=${encodeURIComponent(file)}` : ''}`} replace />;
    }

    // Definite height for FoldersTable's h-full root — this route renders
    // outside Layout, so nothing above it establishes one.
    return (
        <div className="h-dvh">
            <MyDocs />
        </div>
    );
}
